import React, { useState } from 'react';

const TicketIcon = (props) => {
  const { handleClick, extraClasses, size = "small", wrapperElement = "div", color = "#000" } = props || {};
  const [WrapperComponent] = useState(wrapperElement);

  return (
    <WrapperComponent
      role="img"
      onClick={handleClick}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon--ticket icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg viewBox="0 0 24 24">
          <g stroke={color} fill="none" fillRule="evenodd">
            <path d="M15.629 15.558l-5.82 5.82-2.13-2.13c.559-.56 1.332-2.024.08-3.276-1.253-1.253-2.717-.48-3.276.08l-2.13-2.131c2.6-2.602 4.54-4.542 5.819-5.82" />
            <path d="M7.807 8.466l6.729-6.729 2.13 2.13c-.559.56-1.332 2.024-.08 3.276 1.253 1.253 2.717.48 3.276-.08l2.13 2.131c-3.207 3.208-5.45 5.45-6.728 6.73" />
            <path
              strokeLinecap="square"
              strokeDasharray="1,3"
              d="M9.861 8.639l6.805 6.805"
            />
          </g>
        </svg>
      </span>
    </WrapperComponent>
  );
};

export default TicketIcon;
